module.exports = __webpack_public_path__ + "static/media/human2.370aa2d7.png";